import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthModalProvider } from './context/AuthModalContext';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import ResumeHub from './pages/Resume/ResumeHub';
import EvaluateContractorResume from './pages/Resume/EvaluateContractorResume';
import EvaluateFulltimeResume from './pages/Resume/EvaluateFulltimeResume';
import EvaluateFulltimeCoachResumeAdmin from './pages/Resume/EvaluateFulltimeCoachResumeAdmin';
import UseJDToImproveResume from './pages/Resume/UseJDToImproveResume';
import EmployeeReferRoute from './components/EmployeeReferRoute';
import ReferralRequested from './pages/Admin/ReferralRequested';
import ReferralPanel from './pages/Admin/ReferralPanel';
import BQMock from './pages/BQMock/BQMock';
import InterviewQuestions from './pages/InterviewQuestions/InterviewQuestions';
import AdminRoute from './components/AdminRoute';
import UserManagement from './pages/Admin/UserManagement';
import AiUsageReport from './pages/Admin/AiUsageReport';
import AdminConfiguration from './pages/Admin/AdminConfiguration';
import Profile from './pages/Profile/Profile';

function App() {
  return (
    <BrowserRouter>
      <AuthModalProvider>
        <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* Pathless layout so deep links like /resume/contractor match reliably (path="/" parent can be finicky). */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/resume/contractor" replace />} />
          <Route path="resume" element={<ResumeHub />}>
            <Route index element={<Navigate to="contractor" replace />} />
            <Route path="contractor" element={<EvaluateContractorResume />} />
            <Route path="fulltime" element={<EvaluateFulltimeResume />} />
            <Route path="fulltime-coach" element={<AdminRoute><EvaluateFulltimeCoachResumeAdmin /></AdminRoute>} />
            <Route path="jd-improve" element={<UseJDToImproveResume />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
          <Route path="profile" element={<Profile />} />
          <Route
            path="admin/users"
            element={
              <AdminRoute>
                <UserManagement />
              </AdminRoute>
            }
          />
          <Route
            path="admin/referral-requests"
            element={
              <AdminRoute>
                <ReferralRequested />
              </AdminRoute>
            }
          />
          <Route
            path="admin/referral-panel"
            element={
              <AdminRoute>
                <ReferralPanel />
              </AdminRoute>
            }
          />
          <Route
            path="admin/ai-usage"
            element={
              <AdminRoute>
                <AiUsageReport />
              </AdminRoute>
            }
          />
          <Route
            path="admin/configuration"
            element={
              <AdminRoute>
                <AdminConfiguration />
              </AdminRoute>
            }
          />
          <Route path="employee-refer" element={<EmployeeReferRoute />} />
          <Route path="interview-questions" element={<InterviewQuestions />} />
          <Route path="bq-mock" element={<BQMock />} />
          <Route path="bq-questions" element={<Navigate to="/bq-mock" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthModalProvider>
    </BrowserRouter>
  );
}

export default App;
